import { emptyLayout } from "../../emptyLayout/model"
export class appNav extends emptyLayout {
  constructor(difference) {
    super()
    this.isCustomComponent = true //定制组件
    this.name = "移动端导航栏"
    this.width = 200
    this.height = 24
    this.top = 15
    this.left = 0
    this.titleOptions = [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ]
    this.showLayoutSetting = ["位置尺寸", "边距", "外观"] //显示自由布局设置项 false为不显示，true为显示，数组为显示指定tab
    this.showColsSetting = false //显示单元格设置项 false为不显示，true为显示，数组为显示指定tab
    this.showColsData = false //显示单元格设置项 false为不显示，true为显示，数组为显示指定tab
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
